var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { t } from "../I18N";
import Modal from "../Layout/Modal";
// eslint-disable-next-line import/exports-last
export default class ModalTips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  render() {
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "modal-tip-label", onClick: () => this.setState({ isOpen: true }) }, void 0,
      this.props.label
      ), /*#__PURE__*/
      _jsx(Modal, { isOpen: this.state.isOpen, type: this.props.type, className: "modal-tip-dim" }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, this.props.title),
      this.props.children
      ), /*#__PURE__*/
      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn confirm-button btn-info",
        onClick: () => this.setState({ isOpen: false }) }, void 0,

      t('System', 'Accept')
      )
      )
      )
      ));

  }
}

ModalTips.defaultProps = {
  type: 'info'
};